<template>
  <v-dialog v-model="dialog" no-click-animation persistent fullscreen>
    <v-card :loading="loadingMain" tile :disabled="loadingMain">
      <BarTitle @close="dialog = false" title="Medição MOP"></BarTitle>
      <template slot="progress">
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </template>
      <v-toolbar flat>
        <v-toolbar-title>Medições MOP</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              color="primary"
              @click="exportPdf()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon> mdi-file-pdf-box </v-icon>
            </v-btn>
          </template>
          <span>Histórico</span>
        </v-tooltip>

        <v-spacer></v-spacer>
        <!-- <v-btn
          :loading="loadingApproved"
          :disabled="loadingApproved || approved"
          @click="showMeteringByTeam()"
          x-large
          color="primary"
          class="mr-8"
          >Medição por equipe</v-btn
        > -->

        <!-- <v-btn
          :loading="loadingApproved"
          :disabled="loadingApproved || approved"
          @click="approvedContract()"
          x-large
          color="success"
          class="mr-8"
          >aprovar</v-btn
        > -->

        <v-btn
          :loading="loadingSave"
          :disabled="loadingSave || approved"
          @click="save('close')"
          x-large
          color="primary"
          >SALVAR</v-btn>
      </v-toolbar>
      <v-divider class="mb-4"></v-divider>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select
              disabled
              dense
              hide-details
              value="mop"
              return-object
              :items="[{ value: 'mop', text: team.name }]"
              outlined
              label="Equipe"
            ></v-select>
            <!-- <b>SUB-EMPRETEIRO :</b> {{ contractor.fantasy_name }} -->
          </v-col>
          <v-col>
            <v-text-field
              dense
              hide-details
              label="Período"
              :disabled="true"
              v-model="formatPeriod"
              outlined
            ></v-text-field>
            <!-- <b>PERÍODO :</b> -->
            <!-- {{
                formatDate(contract.date_start) + " - " + formatDate(contract.date_end)
            }} -->
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              dense
              hide-details
              label="Medição N°"
              disabled
              outlined
              v-model="meteringMop.metering_n"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              dense
              hide-details
              label="Data Aprovação"
              :disabled="true"
              v-model="formatTextApproved"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-card outlined>
              <v-data-table
                dense
                :headers="headers"
                :items="contractSummaryItems"
                disable-pagination
                hide-default-footer
                class="elevation-0"
              >
                <!-- <template v-slot:top>
                  <v-toolbar flat dense>
                    <v-toolbar-title>Serviços</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="dialogAddServiceDetached()"
                      :disabled="approved"
                      dense
                      rounded
                      color="primary"
                      ><v-icon>mdi-plus</v-icon>Serviço
                    </v-btn>
                  </v-toolbar>
                </template> -->

                <!-- ITEM -->
                <template v-slot:item.item="{ item }">
                  {{ contractSummaryItems.indexOf(item) + 1 }}
                </template>
                <!-- local -->
                <template v-slot:item.local="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{
                        item.local.length > 10
                          ? item.local.substring(0, 10) + " ..."
                          : item.local.substring(0, 10)
                      }}</span>
                      <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                          Button
                        </v-btn> -->
                    </template>
                    <span>{{ item.local }}</span>
                  </v-tooltip>
                </template>
                <!-- QUANTIDADE -->
                <template v-slot:item.quantity="{ item }">
                    <div v-if="no_edit" class="mr-2">
                      {{ formatMoney(item.quantity) }}
                    </div>
                  <v-edit-dialog
                    v-else
                    :return-value.sync="item.quantity"
                    @save="calcSubtotalHH"
                  >
                    <div class="editable mr-2">
                      {{ formatMoney(item.quantity) }}
                    </div>
                    <template v-slot:input>
                      <vuetify-money v-model="item.quantity"></vuetify-money>
                    </template>
                  </v-edit-dialog>

                </template>

                <!-- HH UNITARIO -->
                <template v-slot:item.hh_unit="{ item }">
                  {{ formatMoney(item.hh_unit) }}
                </template>

                <template v-slot:item.sub_total="{ item }">
                  {{ formatMoney(item.sub_total) }}
                </template>

                <template v-slot:no-data> Nenhum item na lista. </template>

                <template v-slot:item.actions="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="float-right"
                        :disabled="item.type_item != 'metering_detached'"
                        color="error"
                        icon
                        @click="removeServiceDetached(item)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        v-if="item.type_item != 'metering_detached'"
                        class="float-right"
                        color="primary"
                        icon
                        @click="showMetering(item)"
                      >
                        <v-icon>mdi-open-in-new </v-icon>
                      </v-btn>
                    </template>
                    <span>Controle de Medição</span>
                  </v-tooltip>
                </template>
                <template v-slot:foot>
                  <tr>
                    <td
                      style="background: lightgray; height: 35px"
                      class="text-right"
                      colspan="7"
                    >
                      SUBTOTAL:
                    </td>
                    <td
                      style="
                        background: lightgray;
                        height: 35px;
                        padding-left: 16px;
                        padding-right: 16px;
                      "
                      class="text-right"
                    >
                      <b>{{ formatMoney(subtotalContractorItems()) }}</b>
                    </td>
                    <td
                      style="
                        background: lightgray;
                        height: 35px;
                        padding-left: 16px;
                        padding-right: 16px;
                      "
                    ></td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <!-- OBSERCVACAO -->
          <v-col cols="5" class="">
            <v-textarea
              :disabled="no_edit"
              style="font-family: sans-serif"
              hide-details
              v-model="meteringMop.obs"
              rows="12"
              label="Observações"
              class=""
              outlined
            ></v-textarea>
          </v-col>

          <!-- FUNCOES -->
          <v-col>
            <div>
              <v-card
                :disabled="loading_metering_mop_employee_role"
                elevation="0"
                style="font-size: 16px; min-height: 318px; background: #d3d3d3"
                tile
              >
                <v-progress-linear
                  v-show="loading_metering_mop_employee_role"
                  indeterminate
                ></v-progress-linear>

                <v-row
                  style="
                    font-size: 18px;
                    background: #1976d2;
                    color: white;
                    height: 30px;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                  "
                  no-gutters
                >
                  <v-col cols="4"><b class="ml-2">SUBTOTAL 1</b></v-col>
                  <v-col cols="2"></v-col>
                  <v-col cols="2" class="text-right" style="">
                    <b
                      class="mr-2"

                      >{{ formatMoney(subtotalContractorItems()) }}</b
                    >
                  </v-col>
                  <v-col cols="2" class="text-right" style="">
                    <b>{{ formatMoney(meteringMop.unit_price_hh_config) }}</b>
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <b class="mr-2">{{
                      formatMoney( meteringMop.unit_price_hh_config * subtotalContractorItems())
                    }}</b>
                  </v-col>
                </v-row>
                <v-row
                  v-for="(item, index) in metering_mop_employee_team"
                  :key="'e-' + index"
                  style="background: lightgray; height: 25px"
                  no-gutters
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col cols="4" v-bind="attrs" v-on="on">
                        <v-row no-gutters>
                          <v-col>
                            <div class="ml-2" style="font-size: 14px">
                              <!-- <v-icon
                              @click="removeEmployeeRole(item)"
                              style="cursor: pointer"
                              color="error"
                              class="mr-1"
                              >mdi-delete</v-icon
                            > -->
                              {{ item.name }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </template>
                    <span>{{ item.name }}</span>
                  </v-tooltip>
                  <v-col cols="2" style="font-size: 14px">{{
                    item.employee_role.description
                  }}</v-col>
                  <v-col cols="2" class="text-right">
                    <div v-if="no_edit">{{ formatMoney(item.quantity) }}</div>
                    <v-edit-dialog
                       v-else
                      :return-value.sync="item.quantity"
                      @save="calcSubtotal"
                    >
                      <div
                        class="editable mr-2"

                      >
                        {{ formatMoney(item.quantity) }}
                      </div>
                      <template v-slot:input>
                        <vuetify-money v-model="item.quantity"></vuetify-money>
                      </template>
                    </v-edit-dialog>
                    <!-- <div class="">{{ formatMoney(item.quantity) }}</div> -->
                  </v-col>

                  <v-col cols="2" class="text-right">
                    <v-row no-gutters>
                      <v-col> </v-col>
                      <v-col>
                        <div v-if="no_edit">{{ formatMoney(item.unit_price_hh) }}</div>
                        <v-edit-dialog
                            v-else
                          :return-value.sync="item.unit_price"
                          @save="calcSubtotal"
                        >
                          <div class="editable">
                            {{ formatMoney(item.unit_price_hh) }}
                          </div>
                          <template v-slot:input>
                            <vuetify-money v-model="item.unit_price_hh"></vuetify-money>
                          </template>
                        </v-edit-dialog>
                        <!-- <div class="">{{ formatMoney(item.unit_price_hh) }}</div> -->
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <b class="mr-2">{{ formatMoney(item.sub_total) }}</b>
                  </v-col>
                </v-row>
                <v-row style="background: #1976d2; height: 25px; color: white" no-gutters>
                  <v-col cols="4"><b class="ml-2">TOTAL</b></v-col>
                  <v-col cols="2" class="text-right" style="font-size: 14px"></v-col>
                  <v-col cols="3" class="text-right" style="font-size: 14px"></v-col>
                  <v-col cols="3" class="text-right">
                    <b class="mr-2">{{ formatMoney(totalTeam) }}</b>
                  </v-col>
                </v-row>

                <v-row
                  class="mt-1"
                  style="background: #1976d2; height: 25px; color: white"
                  no-gutters
                >
                  <v-col cols="4"><b class="ml-2">RATEIO</b></v-col>
                  <v-col cols="2"></v-col>
                  <v-col cols="2" class="text-right" style="font-size: 14px">%</v-col>
                  <v-col cols="2" class="text-right" style="font-size: 14px"></v-col>
                  <v-col cols="2" class="text-right"> </v-col>
                </v-row>
                <v-row
                  v-for="(item, index) in metering_mop_employee_team"
                  :key="'r-' + index"
                  style="background: lightgray; height: 25px"
                  no-gutters
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col cols="4" v-bind="attrs" v-on="on">
                        <v-row no-gutters>
                          <v-col>
                            <div class="ml-2" style="font-size: 14px">
                              <!-- <v-icon
                              @click="removeEmployeeRole(item)"
                              style="cursor: pointer"
                              color="error"
                              class="mr-1"
                              >mdi-delete</v-icon
                            > -->
                              {{ item.name }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </template>
                    <span>{{ item.name }}</span>
                  </v-tooltip>
                  <v-col cols="2" style="font-size: 14px">{{
                    item.employee_role.description
                  }}</v-col>
                  <v-col cols="2" class="text-right">
                    <b>{{ formatMoney(item.rateio_percentage) }} %</b>
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <b>{{ formatMoney(item.rateio_value) }}</b>
                  </v-col>
                  <v-col cols="2" class="text-right pr-2">
                    <b>{{ formatMoney(item.rateio_sub_total) }}</b>
                  </v-col>
                </v-row>
              </v-card>
              <v-row no-gutters>
                <v-col>
                  <v-row no-gutters style="background: lightgray">
                    <v-col cols="4" class="text-center"> </v-col>
                    <v-col> </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row
                no-gutters
                style="
                  font-size: 18px;
                  font-weight: bold;
                  background: #1976d2;
                  color: white;
                  height: 30px;
                  border-bottom-left-radius: 5px;
                  border-bottom-right-radius: 5px;
                "
              >
                <v-col class="ml-2">TOTAL:</v-col>
                <v-col class="text-right mr-2"> {{ formatMoney(totalRateio) }}</v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- ADICIONAR SERVIÇO -->
    <AddService @confirm="addServiceDetached" v-model="dialogAddService"></AddService>
    <DialogRole
      v-model="dialogAddRole"
      :meterigMopId="metering_mop_id"
      @metering_mop_employee_role="set_metering_mop_employee_role"
    >
    </DialogRole>
    <!-- <DialogMeteringMopTeam
      v-model="dialogMeteringTeam"
      :metering_mop_id="metering_mop_id"
    ></DialogMeteringMopTeam> -->
  </v-dialog>
</template>

<script>
import BarTitle from "@/pages/Components/BarTitle.vue";
import AddService from "../DialogAddService";
// import DialogMeteringMopTeam from "./DialogMeteringMopTeam.vue";
import DialogRole from "../DialogRole.vue";
import { mapActions } from "vuex";
import units from "@/plugins/units.js";

export default {
  props: {
    value: {
      type: Boolean,
    },
    metering_mop_id: { type: Number },
    team: { type: Object, default: () => ({}) },
    no_edit: { type: Boolean, default: false },
  },
  components: {
    BarTitle,
    AddService,
    DialogRole,
    // DialogMeteringMopTeam,
  },

  data: () => ({
    erroQuantityEmployee: false,
    totalRateio: 0,
    dialogMeteringTeam: false,
    dialog: false,
    meteringMop: {},
    dialogAddService: false,
    dialogAddRole: false,
    approved: false,
    userApproved: "",
    total: 0,
    subTotal2: 0,
    subTotal1: 0,
    itemsUnits: units.units,
    loadingMain: false,
    loadingSave: false,
    loadingApproved: false,
    newServicesDetached: [],
    contract: {
      obs: "",
      metering_n: "",
      date_approved: "",
      date_start: "",
      date_end: "",
    },
    contractSummaryItems: [],
    metering_contract_item_deleted: [],

    metering_mop_item_deleted: [],
    new_services_detached: [],

    metering_mop_expenses: [],
    metering_mop_taxes: [],
    metering_mop_employee_team: [],
    metering_mop_employee_role: [],
    loading_metering_mop_employee_role: false,
    totalTeam: 0,
    errors: {
      contractor: null,
    },

    headers: [
      {
        text: "ITEM",
        value: "item",
      },
      {
        text: "CC",
        value: "cc",
      },
      {
        text: "SERVIÇO",
        value: "service",
      },
      {
        text: "LOCAL",
        value: "local",
      },
      {
        text: "UND",
        value: "unity",
      },
      {
        text: "QUANTIDADE",
        value: "quantity",
        align: "right",
      },
      {
        text: "HH UNIT",
        value: "hh_unit",
        align: "right",
      },
      {
        text: "HH TOTAL",
        value: "sub_total",
        align: "right",
      },
      {
        text: "",
        value: "actions",
        aling: "end",
      },
    ],
    headers_subtotal1: [
      {
        text: "SUB-TOTAL 1",
        value: "",
      },
      {
        text: "",
        value: "",
      },
      {
        text: "",
        value: "",
      },
      {
        text: "",
        value: "",
      },
    ],
  }),

  watch: {
    value(val) {
      this.dialog = val;
      if (val) {
        this.initialize();
      }
    },
    dialog(val) {
      this.$emit("input", val);
    },
  },
  mounted() {},
  computed: {
    formatPeriod() {
      if (this.meteringMop.date_start) {
        return (
          this.formatDate(this.meteringMop.date_start) +
          " - " +
          this.formatDate(this.meteringMop.date_end)
        );
      }
      return "";
    },
    formatTextApproved() {
      if (this.meteringMop.date_approved) {
        return (
          this.formatDateTime(this.meteringMop.date_approved) +
          "   Por: " +
          this.userApproved
        );
      }

      return "";
    },
  },

  methods: {
    ...mapActions("MeteringMop", [
      "getMeteringMopTeam",
      "saveMeteringMopTeam",
      "getContractSummary",
      "updateCreateContractorSummary",
      "approvedServices",
      "getExportPdf",
      "getContractors",
      "deleteEmployeeRole",
    ]),
    initialize() {
      this.clearData();

      this.loadingMain = true;
      const data = {
        metering_mop_id: this.metering_mop_id,
        team_id: this.team.id,
      };
      this.getMeteringMopTeam(data)
        .then((response) => {
          this.meteringMop = response.data;
          this.loadData(response);

        })
        .finally(() => {
          this.loadingMain = false;
        });
    },
    loadData() {
      // se o contracto for aprovado
      this.meteringMop.approved == "yes"
        ? (this.approved = true)
        : (this.approved = false);

      this.meteringMop.approved_by
        ? (this.userApproved = this.meteringMop.approved_by_user.name)
        : "";

      if (this.meteringMop.team) {
        this.metering_mop_employee_team = this.meteringMop.team.employees;
      }

      if (this.meteringMop.metering_mop_employee_role.length > 0) {
        this.metering_mop_employee_role = this.meteringMop.metering_mop_employee_role;
      }

      this.contractSummaryItems = this.meteringMop.metering_mop_items;

      this.meteringMop.date_start = this.meteringMop.physical_progress.date_start;
      this.meteringMop.date_end = this.meteringMop.physical_progress.date_end;

      this.calcSubtotalHH();
    },
    clearData() {
      //define items depesas padrao
      this.metering_mop_employee_role = [];
      //limpa o array de item deletados
      this.metering_contract_item_deleted = [];
      //limpa array de novos serviços avulsos
      this.newServicesDetached = [];
      this.contractSummaryItems = [];

      this.approved = false;
      this.userApproved = "";
      this.contract = {};
    },
    close() {
      this.$emit("input", false);
    },

    calcSubtotal() {
      this.metering_mop_employee_team.map((item) => {
        item.sub_total = item.quantity * item.unit_price_hh;
      });

      let total_employees = this.metering_mop_employee_team.reduce((acc, item) => {
        return acc + (item.sub_total || 0);
      }, 0);

       this.totalTeam = (this.meteringMop.unit_price_hh_config * this.subtotalContractorItems()) - total_employees;



      //verifica se a soma das quantidade por funcionario
      //é igual a quantidade total dos serviços realizado pelo equipe
      const totalQuantityEmployee = this.metering_mop_employee_team.reduce(
        (acc, item) => {
          return acc + parseFloat(item.quantity);
        },
        0
      );

      if (
        parseFloat(totalQuantityEmployee).toFixed(2) !=
        parseFloat(this.subtotalContractorItems()).toFixed(2)
      ) {
        this.erroQuantityEmployee = true;
        //this.$toast.error("A soma das quantidades por funcionário é diferente da quantidade total dos serviços.");
      } else {
        this.erroQuantityEmployee = false;
      }

      //calcula a porcentagem
      this.metering_mop_employee_team.map((item) => {
        item.rateio_percentage = (item.sub_total / total_employees) * 100;
      });

      //sub total rateio
      this.metering_mop_employee_team.map((item) => {
        item.rateio_value = this.totalTeam; //define a propriedade rateio_value
        item.rateio_sub_total = (item.rateio_percentage / 100) * this.totalTeam;
      });

      this.totalRateio = this.metering_mop_employee_team.reduce((acc, item) => {
        return acc + (item.rateio_sub_total || 0);
      }, 0);
    },
    //abri uma tela com a medicao
    showMetering(item) {
      let composition_id = item.composition_id;
      let stage_id = item.stage_id;
      let physical_progress_id = this.meteringMop.physical_progress_id;
      let route = this.$router.resolve(
        "/system/physical_progress/edit_physical_progress/" +
          physical_progress_id +
          `/details/${stage_id}/${composition_id}`
      );
      window.open(route.href, "_blank");
    },
    subtotalContractorItems() {
      const result = this.contractSummaryItems.reduce((acc, item) => {
        return acc + parseFloat(item.sub_total);
      }, 0);

      return result;
    },
    /**
     * mostra a medição por equipe
     */
    // showMeteringByTeam() {
    //   this.dialogMeteringTeam = true;
    // },
    showHistoric() {
      this.$router.push("/system/physical_progress/metering_mop/historic");
    },

    dialogAddServiceDetached() {
      this.dialogAddService = true;
    },
    set_metering_mop_employee_role(metering_mop_employee_role) {
      this.metering_mop_employee_role = metering_mop_employee_role;
    },
    /**
     * ADICIONA UMA NOVA FUNÇÃO
     */
    newRole() {
      this.dialogAddRole = true;
    },
    /**
     * REMOVE UMA FUNÇÃO
     */
    removeEmployeeRole(item) {
      this.loading_metering_mop_employee_role = true;
      this.deleteEmployeeRole(item.id)
        .then((response) => {
          this.metering_mop_employee_role = response.data;
          this.$toast.success("Função excluída");
        })
        .finally(() => {
          this.loading_metering_mop_employee_role = false;
        });
    },
    formatDescriptionEmployeeRole(description) {
      if (description.length >= 20) {

        return description.substring(0, 20) + "...";
      } else {
        return description;
      }
    },
    addServiceDetached(service) {
      let serviceDetached = {
        service_id: service.service.id,
        stage_id: service.stage.id,
        cc: service.stage.code + " - " + service.stage.name,
        quantity: service.quantity,
        service: service.service.description,
        hh_unit: service.unit_hh,
        sub_total: service.quantity * service.unit_hh,
        unity: service.service.unit_of_measure,
      };
      this.newServicesDetached.push(serviceDetached);
      this.contractSummaryItems.push(serviceDetached);
      this.save("no_valid");
    },

    exportPdf() {
      this.getExportPdf(this.meteringMop.id)
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "export_summary_mop.pdf");
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .finally(() => {});

      this.$toast.success("Exportando PDF");
    },
    /**
     * SALVAR O CONTRATO E SEUS ITEMS
     */
    save() {

      //valida se o subtotal dos serviços é maior q zero
      if(this.subtotalContractorItems() <= 0){
        this.$toast.error(
          "O SUBTOTAL total das serviços deve ser maior que zero."
        );
        return false;
      }


      // validação de total de rateio maior que zero
        if (this.totalRateio <= 0) {
            this.$toast.error("O total do rateio deve ser maior que zero.");
            return false;
        }

      this.loadingSave = true;
      this.loadingMain = true;

      const data = {
        metering_mop_id: this.meteringMop.id,
        team_id: this.team.id,
        metering_mop_items: this.contractSummaryItems,
        metering_mop_employee_team: this.metering_mop_employee_team,
        unit_price_hh_config: this.meteringMop.unit_price_hh_config,
        obs: this.meteringMop.obs,
      };
      this.saveMeteringMopTeam(data)
        .then(() => {
          this.dialog = false
          this.$toast.success("Salvo com sucesso.");

        })
        .catch((error) => {
          if (error.response.status == 423) {
            this.$toast.error(error.response.data);
          }
        })
        .finally(() => {
          this.loadingSave = false;
          this.loadingMain = false;
        });
    },

    /**
     * Inverte Sinal
     */
    invertSinal(item) {
      item.fator = item.fator * -1;
      this.calcTotal();
    },
    /**
     * APROVAR SERVIÇOS DO EMREITEIRO EM UM PERIODO ESPECIFICO
     */

    approvedContract() {
      this.save("approve");
    },
    sendApproved() {
      this.loadingApproved = true;
      this.approvedServices()
        .then(() => {
          //fechar o modal de controle de medicoes
          //this.$emit("refreshTable");
          //this.close();
          this.$toast.success("Controle de medição aprovado. ");
        })
        .finally(() => {
          this.loadingApproved = false;
        });
    },
    /**
     * ADICIONA NOVO SERVIÇO
     */
    showAddService() {
      this.dialogAddService = true;
    },

    /**
     * REMOVE UM ITEM DE SERVICOS
     */
    removeService(service) {
      this.metering_contract_item_deleted.push(Object.assign({}, service));
      const index = this.metering_contract_item.indexOf(service);
      this.metering_contract_item.splice(index, 1);
    },
    /**
     * REMOVE UM ITEM DE SERVICOS AVULSO
     */
    removeServiceDetached(service) {
      this.metering_mop_item_deleted.push(Object.assign({}, service));
      const index = this.contractSummaryItems.indexOf(service);
      this.contractSummaryItems.splice(index, 1);
      this.save("no_valid");
    },

    calcSubtotalHH() {
      this.contractSummaryItems.forEach((item) => {
        item.sub_total = parseFloat(item.quantity) * parseFloat(item.hh_unit);
      });
      this.calcSubtotal();
    }, //DESCONTINUADO

    /**
     *CALCULA OS SUB-TOTAIS DE CADA SERVIÇO
     */ calcTotal() {
      //sub total de cada linha do SUBTOTAL1
      this.metering_mop_employee_role.forEach((item) => {
        item.sub_total = parseFloat(item.base) * parseFloat(item.fator);
      });

      //   this.metering_mop_expenses.forEach((item) => {
      //     item.sub_total = parseFloat(item.base) * parseFloat(item.fator);
      //   });

      //   //sub total de cada linha do SUBTOTAL2
      //   this.metering_mop_taxes.forEach((item) => {
      //     item.sub_total = parseFloat(item.base) * (parseFloat(item.fator) / 100);
      //   });

      //somatorio de subtotais do SUBTOTAL1
      let sumSubtotal1 = this.metering_mop_employee_role.reduce((acc, item) => {
        return acc + parseFloat(item.sub_total);
      }, 0);

      let result = this.subtotalContractorItems() - parseFloat(sumSubtotal1);

      //somatorio de subtotais do SUBTOTAL2
      //   let sumSubtotal2 = this.metering_mop_taxes.reduce((acc, item) => {
      //     return acc + parseFloat(item.sub_total);
      //   }, 0);

      //total
      this.total = parseFloat(result);
    },

    /**
     * FORMATA FLOAT PARA MONETARIO
     * @param number
     */
    formatMoney(number) {
      if (isNaN(number)) {
        return 0;
      }
      number = parseFloat(number);

      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatDate(date) {
      if (date) {
        let date_split = date.split("-");
        return date_split[2] + "/" + date_split[1] + "/" + date_split[0];
      }
      return "";
    },
    formatDateTime(date) {
      if (date) {
        date = new Date(date);
        let dateTime =
          date.getDate() + "/" + date.getMonth() + "/" + date.getFullYear() + " ";
        dateTime += date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
        return dateTime;
      }

      return "";
    },
  },
};
</script>

<style scoped>
.editable {
  color: #1976d2;
  font-weight: bold;
}
</style>
